import axios from 'axios';
import logger from '../logger';
import Service from './networkService';
import Constant from '../constants/messages';
import HELPER from '../helper';

let baseOptions = {
  headers: {
    'Content-Type': 'application/json',
  },
  validateStatus: function(status) {
    return true;
  },
};
const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export default async function axiosCall(
  method,
  url,
  data = {},
  withCredentials = true,
  whitelist = true,
  isPDFByteArray = false,
  isBulkUpload = false,
  blobResponseType = false,
  extraOptions = {}
) {

  const options = data && method === 'get' ? data : {};
  const dataKey = method === 'get' ? 'params' : 'data';
  let apiData = data ? { method, url, [dataKey]: data } : { method, url };
  const headers = await setAuthToken(isBulkUpload, url);
  apiData = { ...apiData, ...baseOptions, withCredentials: withCredentials, ...options, ...extraOptions };
  apiData.headers = { ...headers, ...apiData.headers };
  if (blobResponseType) {
    apiData.responseType = 'blob';
  }
  if(isPDFByteArray) {
    apiData.responseType = 'arraybuffer';
  };
  return new Promise(resolve => {
    axios(apiData)
      .then(async response => {
        response = await getMessages(response, url);
        // Service.setupInterceptors(response);
        if (whitelist) {
          Service.errorResponseHandler(response.data);
        }
        resolve(response);
      })
      .catch(err => {
        // Handle TypeError
        if (axios.isCancel(err)) {
          resolve(err); 
          return;
        }
        if (whitelist) {
          logger(err);
        }
        resolve(err);
      });
  });
}

const setAuthToken = async (isBulkUpload, url) => {
  const headers = {};
  if (url.includes('kubedev03.tekclansolutions.com')) {
    headers.Authorization = 'Bearer PSEUDO-PDS-SECRET';
    return headers;
  }
  if (!url.startsWith(HELPER.SERVER_URL)) return;
  if (url.startsWith(HELPER.AUTH_SERVICE_URL)) return;
  if (isBulkUpload) {
    headers.subscriptionKey = process.env.REACT_APP_VAR_UPLOAD_SUBSCRIPTION_KEY;
  }
  if (localTimeZone) headers.timeZone = `${localTimeZone}`;
  return headers;
};

const getMessages = (response, url) => {
  if (url.includes('/auth')) return response;
  if (response.data.statusCode) {
    response.data.status = Constant.success[response.data.statusCode] || response.data.status;
  }
  return response;
};